module.exports = __webpack_public_path__ + "static/img/07dabao.99f74241.gif";